import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { ConversionCargo } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import React from 'react';

import { CargoSelectionResultItemContainer } from './CargoSelectionResultItemContainer';
import { CargoSelectionResultItemTruck } from './CargoSelectionResultItemTruck';

interface CargoSelectionResultListProps {
  selectedCargo: ConversionCargo;
  BaseData: RouteWidgetBaseParameters;
  mainLanguage: string;
}

function CargoSelectionResultList({
  selectedCargo,
  BaseData,
  mainLanguage,
}: CargoSelectionResultListProps) {
  return (
    <div className={'selection-result-list'}>
      {selectedCargo.containerParameters.map((container, index) => (
        <CargoSelectionResultItemContainer
          key={'selection-result-container-item-full' + index}
          containerParameter={container}
          BaseData={BaseData}
          mainLanguage={mainLanguage}
          containerIndex={index}
          outputType="full"
        />
      ))}
      {selectedCargo.truckParameters.map((truck, index) => (
        <CargoSelectionResultItemTruck
          key={'selection-result-truck-item-' + index}
          truckParameter={truck}
          BaseData={BaseData}
          mainLanguage={mainLanguage}
          truckIndex={index}
          outputType="full"
        />
      ))}
    </div>
  );
}

export { CargoSelectionResultList };
